import { Button, Stack, Typography } from '@mui/material';
import { PlusIcon } from '@schooly/style';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { ModalEmpty } from '../../../../../components/uikit-components/Modal/ModalEmpty';

export const SchoolTuneAgeGroupsEmptyStub: FC = () => {
  return (
    <Stack sx={{ height: '100%' }}>
      <Typography variant="h2" mb={2.5}>
        <FormattedMessage id="school-tabs-AgeGroups" />
      </Typography>

      <ModalEmpty width="300px">
        <Typography variant="h3" color={(theme) => theme.palette.common.grey2}>
          <FormattedMessage id="school-tabs-AgeGroups-EmptyMessage" />
        </Typography>
        <Link to="age_groups">
          <Button startIcon={<PlusIcon />}>
            <FormattedMessage id="school-tabs-AgeGroups-AddAgeGroup" />
          </Button>
        </Link>
      </ModalEmpty>
    </Stack>
  );
};
